import React, { Component } from 'react';

import DashboardView from './DashboardView';

export default class DashboardContainer extends Component {
  render() {
    return (
      <DashboardView onMenuSelect={this.props.onMenuSelect} />
    );
  }
}